import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Header.module.scss';
import { useAppDispatch } from '../../../store';
import { setUserEmail } from '../../../store/slices/userSlice';
import { resetQuiz } from '../../../store/slices/quizSlice';
import { resetFormData } from '../../../store/slices/formDataSlice';
import { clearPayment } from '../../../store/slices/paymentSlice';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogoClick = () => {
    navigate('/');
    dispatch(setUserEmail(''));
    dispatch(resetQuiz());
    dispatch(resetFormData());
    dispatch(clearPayment());
    sessionStorage.clear();
  };

  return (
    <header className={styles.header}>
      <span className={styles.logo} onClick={handleLogoClick} />
    </header>
  );
};

export default Header;
